import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { AngularFireDatabase } from '@angular/fire/database';
import { SlicePipe } from '@angular/common';

@Component({
  selector: 'app-chat',
  templateUrl: './chat.component.html',
  styleUrls: ['./chat.component.scss'],
})
export class ChatComponent implements OnInit {
  @ViewChild('chatContent', {static: true}) private content: any;

  user: string;
  message: string;
  messages: any;
  uid: string;
  name: string;
  channel: string;
  channelId: string;

  constructor(public db: AngularFireDatabase) {
  }

  ngOnInit() {
    this.scrollToBottomOnInit();
    this.channelId = localStorage.getItem('channelId');
    console.log('channel Id', this.channelId);
    // this.user = this.navParam.get('user');
    // this.uid = localStorage.getIem('uid');
    
    this.name = 'Hammond BUrke'; // localStorage.getItem('name');
    this.db.list(`/chat/channels/${this.channelId}`).valueChanges().subscribe(data => {
      this.messages = data;
    });
  }

  scrollToBottomOnInit() {
    this.content.scrollToBottom(300);
  }

  sendMessage(){
    let chatTime = Math.floor(Date.now() / 1000);
    this.db.list(`/chat/channels/${this.channelId}`).push({
      userName: this.name,
      message: this.message,
      dateTime: this.ts(chatTime)
    }).then(() => {
      this.message = '';
    });

    
  }
    ts = function(timestamp) {
    let ts_ms = timestamp * 1000;
    let date_obj = new Date(ts_ms);
    let ts_year = date_obj.getFullYear();
    let ts_month = ("0" + (date_obj.getMonth() + 1)).slice(-2);
    let ts_date = ("0" + date_obj.getDate()).slice(-2);
    let ts_hours = ("0" + date_obj.getHours()).slice(-2);
    let ts_minutes = ("0" + date_obj.getMinutes()).slice(-2);
    let ts_sesonds = ("0" + date_obj.getSeconds()).slice(-2);

    return ts_month + "-" + ts_date + "-" + ts_year + " " + ts_hours + ":" + ts_minutes + ":" + ts_sesonds;

  }

}
